export default __webpack_public_path__ + "static/sketch_coverage_partial-e797079e0006a2c8bcea08cb13860a73.png";